export default __webpack_public_path__ + "static/media/stars.791abca2.gif";